// src/config/animationConfig.ts

export const AnimationConfig = {
  text: {
    wordsPerChunk: 2,         // Number of words per chunk
    chunkDelay: 20,           // Delay between chunks in ms
    animationDuration: 0.8,   // Duration of each chunk animation in seconds
    startDelay: 0,          // Initial delay before starting animation in ms
  },
  sections: {
    transitionDuration: 0.3,  // Duration of section transitions
    delayBetweenSections: 500, // Delay between major sections (questions -> resolved -> current)
  },
  easing: {
    spring: [0.34, 1.56, 0.64, 1],  // Springy easing for pop-in effects
    smooth: [0.4, 0, 0.2, 1],       // Smooth easing for fade effects
  }
};